import release from './release';
import releaseValidation from './validation';

export const services = {
  release,
  'release-validation': releaseValidation,
};
